import React from "react";
import "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import "../assets/styles/Timeline.scss";

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>PROFESSIONAL EXPERIENCE</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: "white", color: "rgb(39, 40, 34)" }}
            contentArrowStyle={{ borderRight: "7px solid  white" }}
            date="Jan 2024 – present"
            iconStyle={{ background: "#5000ca", color: "rgb(39, 40, 34)" }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">DataKind</h3>
            <h4 className="vertical-timeline-element-subtitle">
              Brooklyn, NY
            </h4>
            <h4>Senior Data Engineer</h4>
            <p>
              Designed and maintained scalable data platforms by building Python, PySpark, Airflow, Kafka, and Snowflake pipelines that enabled reliable analytics, real-time event processing, and data-driven product insights.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Mar 2019 – Dec 2023"
            iconStyle={{ background: "#5000ca", color: "rgb(39, 40, 34)" }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">
              Confluent
            </h3>
            <h4 className="vertical-timeline-element-subtitle">Mountain View, CA</h4>
            <h4>Data Engineer</h4>
            <p>
              Built end-to-end data and analytics solutions using Python, Spark, Airflow, data warehouse modeling, Node.js APIs, and React dashboards to support ticketing, revenue, marketing, and operational reporting.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Jul 2017 - Feb 2019"
            iconStyle={{ background: "#5000ca", color: "rgb(39, 40, 34)" }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Tech Innovators of America</h3>
            <h4 className="vertical-timeline-element-subtitle">Dublin, CA</h4>
            <h4>Software Engineer</h4>
            <p>
              Worked on enterprise SaaS platforms and internal analytics tools
              for business operations.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Apr 2013 - May 2017"
            iconStyle={{ background: "#5000ca", color: "rgb(39, 40, 34)" }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">
              University of Houston - Downtown
            </h3>
            <h4 className="vertical-timeline-element-subtitle">
              Houston, TX
            </h4>
            <p>Bachelor of Science in Computer Science</p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;
